export default {
  Title: 'Invoices',
  buttonNewInvoice: 'New Invoice',
  buttonCancelInvoice: 'Cancel Invoice',
  buttonNewInvoiceAndReceipt: 'Receipt / Tax Invoice',
  buttonNewReceipt: 'Receipt',
  Customer: 'Customer',
  buttonPrintInvoice: 'Print Invoice',
  buttonPrintInvoiceTemporary: 'Print Temporary Invoice',
  buttonPrintReceipt: 'Print Receipt',
  buttonPrintReceiptInvoice: 'Print Receipt/Tax Invoice',
  buttonnewCustomerDepartment: 'New Customer Department',
  buttonDeleteCustomer: 'Delete Customer',
  buttonDeleteCustomerDepartment: 'Delete Customer Department',
  newCustomer: 'New Customer',
  editCustomer: 'Edit Customer',
  newCustomerDepartment: 'New Customer Department',
  editCustomerDepartment: 'Edit Customer Department',
  CustomerName: 'Customer',
  CustomerAddress: 'Address',
  confirmDelete: 'Are you sure you want to delete Customer {}?',
  confirmCustomerDepartmentDelete: 'Are you sure you want to delete Customer Department {}?',
  confirmDeleteSelected: 'Are you sure you want to delete selected Customer?',
  confirmCustomerDepartmentDeleteSelected: 'Are you sure you want to delete selected Customer Department?',
  progressMessageDelete: 'Deleting Customer {}',
  progressMessageCustomerDepartmentDelete: 'Deleting Customer Department {}',
  messageDeleteNotSelected: 'Please select Customer to delete',
  messageDeleteDepartmentNotSelected: 'Please select Customer Department to delete',
  tabWindow: 'Window',
  tabDepartment: 'Department',
  AddPicture: 'Add Picture',
  CustomerDetail: 'Customer Detail',
  criteria: 'Criteria',
  Status: 'Status',
  ReceivedDate: 'Received Date',
  ApproveDate: 'Approved Date',
  OrderId: 'Package No.',
  LabNo: 'Lab No.',
  patientName: 'Patient Name',
  gender: 'Gender',
  age: 'Age',
  hn: 'HN',
  labStatus: 'Lab Status',
  totalAmt: 'Total Amount (Baht)',
  InvoiceNo: 'Invoice No.',
  ReceiptNo: 'Receipt No.',
  messageCreateInvoice: 'Are you sure you want to Create Invoice?',
  messageNoSelection: 'Please select Lab.',
  messageDifferentCustomer: 'Different Customer. Please select lab customer {}',
  messageInvoiceExists: 'Package No. {} already have invoices created.',
  messageNotHaveAmt: 'Package No. {} not have amount.',
  messageCreateInvoiceSuccess: 'Invoice has been successfully created. Invoice number: {}',
  OrderItem: 'Order Item',
  OrderItemNo: 'Order Item No',
  price: 'Price (Baht)',
  qty: 'QTY',
  discAmount: 'Discount',
  InvoiceAmount: 'Invoice Amount',
  InvoiceDate: 'Invoice Date',
  ReceiptDate: 'Receipt Date',
  CreatedDate: 'Requested Date',
  CreatedUser: 'Created User',
  messageCreateReceipt: 'Are you sure you want to Create Invoice and Receipt?',
  messagePaymentMethod: 'Please select a payment method.',
  PaymentMethod: 'Payment Method',
  messageCreateInvoiceReceiptSuccess: 'Invoice and Receipt has been successfully created. Invoice number: {}, Receipt number: {}',
  messageAmountZero: 'Please Enter Amount',
  messageCreateReceiptAmtExceedInvAmt: 'Do you want to accept payments that exceed the invoiced amount?',
  messageCreateReceiptAmtlessInvAmt: 'Do you want to accept payments that are less than the invoiced amount?',
  ref1: 'Reference No.',
  ref2: 'Ref.2',
  ref3: 'Ref.3',
  ReceiptAmt: 'Receipt Amt.',
  messageInvoiceNotFound: 'Invoice No. Not Found.',
  dateSend: 'Sent Date',
  TransferSlipDate: 'Transfer Date',
  TransferSlipTime: 'Transfer Time',
  remark: 'Remark',
  buttonExportInvoice: 'Export',
  buttonGenerateDeferredRevenue: 'Generate Deferred Revenue',
  messageAlertNoInvoice: 'Package No. {} Invoice not yet issued',
  messageGenerateDeferredRevenusSuccessfully: 'Generate deferred revenus successfully',
  DeferredRevenue: 'Prepaid Income',
  DeferredRevenueHas: 'There are entries recorded as prepaid income.',
  AttachAmountPaid: 'Paid Amount',
  withHoldingTax: 'Withholding Tax (WHT)',
  withHoldingTaxAmt: 'Net Amount (after WHT)',
  InvoiceTemporary: 'Invoice Temporary',
  buttonAutoSelect: 'Auto Select',
  messagePleaseSelectCustomer: 'Please select a customer.',
  AttachAmountPaidInvScreen: 'Received Amount',
  BankTransfer: 'Transferring Bank',
  messageSelectInvoiceBeforePrint: 'Please select an order item.',
  messagePleaseSelectCRD: 'Please select the payment information as credit.',
  messageReceiptNotFound: 'Receipt No. Not Found.',
  AttachAmountPaidTransfer: 'Transferred Amount',
  searchData: 'Search Data',
}
